import { IKnmIndex } from 'APIPackage/KnmModule/interfaces/IKnmIndex';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { IKnmRaw } from 'KnmListPackage/MainModule/interfaces/IKnmRaw';

const getRegistryText = (value?: boolean) => {
  let res = '-';

  if (value === true) {
    res = 'Да';
  } else if (value === false) {
    res = 'Нет';
  }

  return res;
};

const getEmptyDateIfAnnouncement = (row: IKnmIndex): string => {
  const start = row.startDate ? formatDate({ date: row.startDate, dateFormat: DATE_FORMAT_LONG_FNS }) : 'Не указано';

  if (row.kind === 'Объявление предостережения' && !row.stopDate) {
    return start;
  }

  const end = row.stopDate ? formatDate({ date: row.stopDate, dateFormat: DATE_FORMAT_LONG_FNS }) : 'Не указано';

  return `${start} – ${end}`;
};

// структура IKnmRaw адаптирована, а не заменена, чтобы не править все ссылки на нее из списка в рамках дорабоки фмльтров
export const mapDataItemToRaw = (row: IKnmIndex) => ({
  ...row,
  startDateEn: getEmptyDateIfAnnouncement(row),
  status: row.status,
  approved: '',
  torRegistryExists: getRegistryText(row.torRegistryExists),
  spvRegistryExists: getRegistryText(row.spvRegistryExists),
  sezRegistryExists: getRegistryText(row.sezRegistryExists),
  resultEmpty: '',
  hasViolations: '',
  inn: row?.inn ? row.inn.split(',').join(', ') : null,
  ogrn: row?.ogrn ? row.ogrn.split(',').join(', ') : null,
});

export const mapRawToData = (data: IKnmIndex[]): IKnmRaw[] => {
  return data.map(row => {
    return mapDataItemToRaw(row);
  });
};
